import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import { alterSiteDrawer } from '~/data/actions/siteActions' //now we can use user actions here
import AdvancedTemplate from './advanced/advanced'
import i18n from '~/i18n'
import Themes from './dragDrop/themes'
import AutomationSteps from '~/Common-Objects/Automations/automationSteps'
import DisplayCard from '~/Common-Objects/UI/DisplayCard'
import { canUseAiTemplateBuilder } from '~/utils/aiTemplateBuilder'
import AiCreateWizard from '~/pages/cp/includes/aiCreateWizard'
import './style.scss'

const TemplatesTemplate = (props) => {
    const dispatch = useDispatch()
    const siteMaster = useSelector((state) => state.siteMaster)
    const accountMaster = useSelector((state) => state.accountMaster)
    const showAiGenerate = canUseAiTemplateBuilder(accountMaster, siteMaster)
    const [scratchMode, setScratchMode] = useState(false)

    const openFromCode = () => {
        props.history.push('/cp/templates/add/fromCode/')
    }

    const openWysiwyg = () => {
        props.history.push('/cp/templates/add/wysiwyg/')
    }

    const openDragDrop = () => {
        dispatch(alterSiteDrawer(true, true, 'left', <Themes history={props.history} />, true, '100vw', 'full'))
    }

    const openAdvanced = () => {
        const drawerContent = <AdvancedTemplate history={props.history} />
        dispatch(alterSiteDrawer(true, true, 'left', drawerContent, true, '100vw', 'full'))
    }

    if (props.match && props.match.params && props.match.params.editorTypeId) {
        if (props.match.params.editorTypeId == 1) {
            //just show drag and drop editor
            let defaultThemeGroupId = null
            if (props.match.params.defaultThemeGroupId) defaultThemeGroupId = props.match.params.defaultThemeGroupId
            return (
                <Paper>
                    <Themes history={props.history} defaultThemeGroupId={defaultThemeGroupId} />
                </Paper>
            )
        }
    }

    if (showAiGenerate && !scratchMode) {
        return (
            <Paper className='templates-add-page' style={{ paddingBottom: 80 }}>
                <AiCreateWizard
                    kind='email'
                    history={props.history}
                    onStartFromScratch={() => setScratchMode(true)}
                    onCancel={() => props.history.push('/cp/templates')}
                />
            </Paper>
        )
    }

    return (
        <Paper className='templates-add-page'>
            <div className='templates-add-page__wrapper'>
                <h2 className='templates-add-page__title'>Create New Template</h2>
                <p className='templates-add-page__description'>
                    Choose how you would like to create your email template.
                </p>
                <DisplayCard inline={true} className='mar-b25' onClick={openDragDrop}>
                    <DisplayCard.Content>
                        <SquareChip className='square-chip-purple mar-b20' value='Recommended' />
                        <h4 className='mar-b10'>{i18n.t('templates:add.dragTitle')}</h4>
                        <p>{i18n.t('templates:add.dragSubTitle')}</p>
                        <Button
                            text={i18n.t('templates:add.dragButton')}
                            iconRight={<Icons icon='arrowRight' />}
                            className='button-primary'
                            onClick={openDragDrop}
                        />
                    </DisplayCard.Content>
                    <DisplayCard.Image>
                        <img
                            src='https://cdn1.ourmailserv.com/siteContent/assets/misc/campaign-builder.png'
                            alt='Transpond Email Template Editor'
                        />
                    </DisplayCard.Image>
                </DisplayCard>
                <AutomationSteps.Group title={'More Options'} style={{ width: '100%' }}>
                    <AutomationSteps.Step
                        icon={
                            <Icons icon='textBlock' color='#7950EA' style={{ width: '20px', height: '20px' }} />
                        }
                        onClick={openWysiwyg}
                        title={<div className='text-heavy'>{i18n.t('templates:add.wysiTitle')}</div>}
                        subTitle={<div style={{ fontSize: 13 }}>{i18n.t('templates:add.wysiSubTitle')}</div>}
                        ctaIcon={
                            <Icons
                                icon='chevronRight'
                                color='#595C61'
                                style={{ width: '20px', height: '20px' }}
                            />
                        }
                        ctaWidth='20px'
                        iconHolderStyle={{ width: '20px', height: '20px' }}
                        postHogTag='create_new_template_plain_text'
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='code' color='#7950EA' style={{ width: '20px', height: '20px' }} />}
                        onClick={openFromCode}
                        title={<div className='text-heavy'>{i18n.t('templates:add.codeTitle')}</div>}
                        subTitle={<div style={{ fontSize: 13 }}>{i18n.t('templates:add.codeSubTitle')}</div>}
                        ctaIcon={
                            <Icons
                                icon='chevronRight'
                                color='#595C61'
                                style={{ width: '20px', height: '20px' }}
                            />
                        }
                        ctaWidth='20px'
                        iconHolderStyle={{ width: '20px', height: '20px' }}
                        postHogTag='create_new_template_code'
                    />
                    <AutomationSteps.Step
                        icon={
                            <Icons
                                icon='documentUpload'
                                color='#7950EA'
                                style={{ width: '20px', height: '20px' }}
                            />
                        }
                        onClick={openAdvanced}
                        title={<div className='text-heavy'>{i18n.t('templates:add.advancedTitle')}</div>}
                        subTitle={<div style={{ fontSize: 13 }}>{i18n.t('templates:add.advancedSubTitle')}</div>}
                        ctaIcon={
                            <Icons
                                icon='chevronRight'
                                color='#595C61'
                                style={{ width: '20px', height: '20px' }}
                            />
                        }
                        ctaWidth='20px'
                        iconHolderStyle={{ width: '20px', height: '20px' }}
                        postHogTag='create_new_template_advanced'
                    />
                </AutomationSteps.Group>
                {siteMaster.siteId === 1 && (
                    <p className='mar-t25'>
                        Need help choosing? Check out our{' '}
                        <a
                            href='https://transpond.io/support/creating-and-sending-campaigns/using-the-drag-drop-editor'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            template creation guide.
                        </a>
                    </p>
                )}
            </div>
        </Paper>
    )
}

export default TemplatesTemplate
